module.exports = __webpack_public_path__ + "static/media/Illus-Pickup_1@3x.01634b08.png";